import React from 'react';
import { Form, Input, Row, Col } from 'antd';

const { TextArea } = Input;

const ClinicAddressFields = ({ disabled = false }) => {
  return (
    <>
      <Form.Item
        label="Clinic Name"
        name="name"
        rules={[{ required: true, message: 'Clinic name is required' }]}
      >
        <Input placeholder="Enter clinic name" disabled={disabled} maxLength={200} />
      </Form.Item>

      <Form.Item
        label="Address"
        name="address"
        rules={[{ required: true, message: 'Address is required' }]}
      >
        <TextArea
          rows={3}
          placeholder="Enter full address"
          disabled={disabled}
          maxLength={500}
          showCount
        />
      </Form.Item>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="City"
            name="city"
            rules={[{ required: true, message: 'City is required' }]}
          >
            <Input placeholder="Enter city" disabled={disabled} maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="State" name="state">
            <Input placeholder="Enter state/region (optional)" disabled={disabled} maxLength={100} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Phone"
            name="phone"
            rules={[{ required: true, message: 'Phone is required' }]}
          >
            <Input placeholder="Enter phone number" disabled={disabled} maxLength={20} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Email" name="email">
            <Input placeholder="Enter email (optional)" disabled={disabled} maxLength={100} type="email" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Postal Code" name="postal_code">
        <Input placeholder="Enter postal code (optional)" disabled={disabled} maxLength={20} />
      </Form.Item>

      <Form.Item label="Description" name="description">
        <TextArea
          rows={4}
          placeholder="Enter clinic description (optional)"
          disabled={disabled}
          maxLength={1000}
          showCount
        />
      </Form.Item>
    </>
  );
};

export default ClinicAddressFields;